// src/screens/Admin/MerchantDetail.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api';
import './MerchantDetail.css';

import backIcon from '../../assets/backspace-icon.png';

function MerchantDetail({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMerchant = async () => {
      try {
        const res = await api.get(`/admin/merchants/${id}`);
        setMerchant(res.data.merchant);
        console.log('🔍 Merchant from backend:', res.data.merchant);
      } catch (err) {
        console.error('❌ Failed to fetch merchant details:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMerchant();
  }, [id]);

  const handleAction = async (action) => {
    try {
      await api.patch(`/admin/merchants/${id}/status`, { status: action });
      alert(`✅ Merchant ${action} successfully`);
      navigate('/admin/merchants');
    } catch (err) {
      console.error(`❌ Failed to ${action} merchant:`, err);
      alert(`Failed to ${action} merchant. Try again.`);
    }
  };

  // 🔴 HARD REVOKE (with safety confirmation)
  const handleRevoke = async () => {
    const ok = window.confirm(
      "⚠️ REVOKE will permanently DELETE this merchant's store and ALL listings.\n\n" +
      "If the merchant has active orders or disputes, revoke will be blocked.\n\n" +
      "Continue?"
    );
    if (!ok) return;

    const typed = window.prompt('Type REVOKE to confirm:');
    if ((typed || '').trim().toUpperCase() !== 'REVOKE') {
      alert('Revoke cancelled.');
      return;
    }

    try {
      await api.post(`/admin/merchants/${id}/revoke`);
      alert('✅ Merchant revoked successfully.');
      navigate('/admin/merchants');
    } catch (err) {
      console.error('❌ Failed to revoke merchant:', err);

      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Failed to revoke merchant.';

      alert(msg);
    }
  };

  if (loading) return <p className="merchantdetail-loading">Loading...</p>;
  if (!merchant) return <p className="merchantdetail-error">Merchant not found.</p>;

  return (
    <div className="merchantdetail-container">
      <div className="merchantdetail-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="merchantdetail-back-icon"
          onClick={() => navigate('/admin/merchants')}
        />
        <h2>Merchant Details</h2>
      </div>

      <div className="merchantdetail-content">
        <p><strong>Owner Username:</strong> {merchant.username}</p>
        <p><strong>Business Username:</strong> {merchant.businessUsername || 'N/A'}</p>
        <p><strong>Business Name:</strong> {merchant.storeName || 'N/A'}</p>

        <p>
          <strong>Status:</strong>{' '}
          {merchant.status === 'approved' && merchant.isMerchant
            ? 'Approved / Active'
            : merchant.status
              ? merchant.status.charAt(0).toUpperCase() + merchant.status.slice(1)
              : 'N/A'}
        </p>

        {merchant.isMerchant && merchant.merchantPaidUntil && (
          <p>
            <strong>Payment Due:</strong>{' '}
            {new Date(merchant.merchantPaidUntil).toLocaleDateString()}
          </p>
        )}

        <p><strong>Email:</strong> {merchant.email || 'Not provided'}</p>
        <p>
          <strong>Application Date:</strong>{' '}
          {merchant.applicationDate
            ? new Date(merchant.applicationDate).toLocaleString()
            : 'N/A'}
        </p>
        <p><strong>Store Description:</strong> {merchant.description || 'No info yet'}</p>
        <p><strong>Location:</strong> {merchant.location || 'No info yet'}</p>
        <p><strong>Total Listings:</strong> {merchant.totalProducts || 0}</p>

        <div className="merchantdetail-actions">
          {merchant.status === 'pending' && (
            <>
              <button
                className="admin-btn approve"
                onClick={() => handleAction('approved')}
              >
                Approve
              </button>
              <button
                className="admin-btn reject"
                onClick={() => handleAction('rejected')}
              >
                Reject
              </button>
            </>
          )}

          {merchant.status === 'approved' && (
            <div className="merchantdetail-approved-actions">
              <button
                className="admin-btn suspend"
                onClick={() => handleAction('suspended')}
              >
                Suspend
              </button>

              {/* 🔴 HARD REVOKE (Stage C + Stage D) */}
              <button
                className="admin-btn revoke"
                onClick={handleRevoke}
              >
                Revoke
              </button>
            </div>
          )}

          {merchant.status === 'suspended' && (
            <button
              className="admin-btn reinstate"
              onClick={() => handleAction('approved')}
            >
              Reinstate
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default MerchantDetail;
